<template>
  <div class="showcase-home-hero-validate">
    <div class="status">{{ statusText }}</div>
    <div class="content">
      <TextField
        class="white outline transparent blur big"
        v-model="inviteCode"
        placeholder="输入邀请码或邀请人"
      />
      <div class="action">
        <button
          class="button outline white transparent blur big"
          @click="onClickActionButton"
        >
          {{ actionButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import TextField from '@/app/components/text-field';

export default defineComponent({
  name: 'ShowcaseHomeHeroValidate',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      defaultStatusText: '独立开发者之路：行尽此路，自如表达。',
      statusText: '独立开发者之路：行尽此路，自如表达。',
    };
  },

  /**
   * 监听
   */
  watch: {
    validateCode() {
      if (this.statusText !== this.defaultStatusText) {
        this.statusText = this.defaultStatusText;
      }
    },
  },

  /**
   * 计算属性
   */
  computed: {
    actionButtonText() {
      return '验证邀请';
    },

    ...mapGetters({
      currentStepName: 'invite/currentStepName',
      _inviteCode: 'invite/validate/inviteCode',
    }),

    inviteCode: {
      get() {
        return this._inviteCode;
      },
      set(data) {
        this.setInviteCode(data);
      },
    },
  },

  /**
   * 已创建
   */
  created() {
    const { inviteCode } = this.$route.query;

    if (inviteCode) {
      this.setInviteCode(inviteCode);
    }
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentStepName: 'invite/setCurrentStepName',
      setValidateCode: 'invite/validate/setValidateCode',
      setInviteCode: 'invite/validate/setInviteCode',
    }),

    ...mapActions({
      validateInvite: 'invite/validate/validateInvite',
      // pushMessage: 'notification/pushMessage',
    }),

    async onClickActionButton() {
      if (!this.inviteCode.trim()) {
        return (this.statusText = '请填写邀请码或邀请人');
        // return this.pushMessage({ content: '请填写邀请码或邀请人' });
      }

      try {
        await this.validateInvite({
          inviteCode: this.inviteCode,
        });

        this.setCurrentStepName('register');
      } catch (error) {
        this.statusText = error.data.message;
        // this.pushMessage({ content: error.data.message });
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    TextField,
  },
});
</script>

<style scoped>
@import './styles/showcase-home-hero-validate.css';
</style>
